/* @ngInject */
function AuditScoreBadgeController ($scope, $translate) {
  $scope.scoreLabel = ''

  activate()

  function activate () {
    $translate.onReady(() => {
      switch (true) {
        case $scope.score <= 2:
          $scope.scoreLabel = $translate.instant('ratings.veryBad')
          break
        case $scope.score <= 5:
          $scope.scoreLabel = $translate.instant('ratings.bad')
          break
        case $scope.score <= 7:
          $scope.scoreLabel = $translate.instant('ratings.regular')
          break
        case $scope.score <= 9:
          $scope.scoreLabel = $translate.instant('ratings.good')
          break
        case $scope.score === 10:
          $scope.scoreLabel = $translate.instant('ratings.veryGood')
          break
      }
    })
  }
}

export { AuditScoreBadgeController }
